import { put, select } from 'redux-saga/effects';

import { actions as lessonActions } from 'common.components/lesson';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { getLessonDefaultName } from 'common.components/lesson/utils';
import { getIsLessonEvaluable } from 'utils/lesson';

import * as actions from '../actions';

export function* setLessonNameByModeSaga(action: ReturnType<typeof actions.setLessonNameByMode>) {
    const { intl, lessonMode } = action.payload;

    try {
        const isLessonNamedByDefault: boolean = yield select(lessonSelectors.getIsLessonNamedByDefault, { intl });

        if (isLessonNamedByDefault) {
            const newLessonName = getLessonDefaultName({ intl, isEvaluable: getIsLessonEvaluable(lessonMode) });

            yield put(
                lessonActions.setName({
                    lessonName: newLessonName,
                })
            );
        }
    } catch (error) {
        console.error(error);
    }
}
